export const calculateUnitDevices = ({ devices }: any) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    if(devices && devices.length > 0) {
        dotValues.green.count =  devices.length;
        for(let device of devices) {
            dotValues.green.labels.push(device.deviceType + " ingevuld");
        }
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Geen toestellen ingevuld");
    }

    return dotValues;
};
